(function ($) {
    $.mobileNav.init();

    $('h1 a').on('click', function (e) {
        e.preventDefault();

        var _jump = $('#' + $(this).data('jump')).offset().top;

        $('html, body').stop().animate(
            {
                scrollTop: _jump,
            },
            500,
            'swing',
        );
    });
})(jQuery);
